export enum CRUDModes {
  Create,
  Update,
  Delete,
}
